export default __webpack_public_path__ + "static/media/quiz.324c5b5d.PNG";